import UIStrings from '@/Utils/UIStrings';

interface DialogCardInterviewBodyProps {
    name: string;
}

function DialogCardInterviewBody({ name }: DialogCardInterviewBodyProps) {
    return (
        <div className="text-foreground text-sm font-normal">
            <span>{`${UIStrings.Click} `}</span>
            <span>{`"${UIStrings.ComposeInvitationEmail}" `}</span>
            <span>{`${UIStrings.InterviewDialogBody3}. ${UIStrings.InterviewDialogBody4} ${name}${UIStrings.InterviewDialogBody5}.`}</span>
        </div>
    );
}

export default DialogCardInterviewBody;
